import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const DruhDokladu = {
	name: NAME,
	apiProvider,
	router,
};
